import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';
import { Container, Title, Button } from "@bsf/force-ui";
import { LoaderCircle } from "lucide-react";
import { Toaster, toast } from 'react-hot-toast';

const MyAccount = () => {
	const [licenseKey, setlicenseKey] = useState('');
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const licenseStatus = uaelSettingsData.license_status;
	const licensePlaceholder = licenseStatus ? __('Your license is active.', 'uael') : __('Paste your license key here', 'uael');

	const activateHandler = () => {
		if (!licenseKey) {
			toast.error(__('Please enter a valid license key!', 'uael'));
			setErrorMessage(__('Enter a valid license key!', 'uael'));
			return;
		}

		setLoading(true);
		setErrorMessage('');

		const formData = new window.FormData();
		formData.append('key', licenseKey);
		formData.append('action', 'uael_license_activation');
		formData.append('security', uaelSettingsData.license_activation_nonce);

		apiFetch({
			url: uaelSettingsData.ajax_url,
			method: 'POST',
			body: formData,
		}).then((data) => {
			setLoading(false);
			if (data.success) {
				toast.success(__('License successfully validated!', 'uael'));
				location.reload();
			} else {
				toast.error(data.message || __('Please enter a valid license key!', 'uael'));
				setErrorMessage(data.message || __('Enter a valid license key!', 'uael')); // Set error message.
			}
		});
	};

	const deactivateHandler = () => {
		setLoading(true);
		setErrorMessage('');

		const formData = new window.FormData();
		formData.append('action', 'uael_license_deactivation');
		formData.append('security', uaelSettingsData.license_deactivation_nonce);

		apiFetch({
			url: uaelSettingsData.ajax_url,
			method: 'POST',
			body: formData,
		}).then((data) => {
			setLoading(false);
			if (data.success) {
				toast.success(__('License successfully deactivated!', 'uael')); // Show toast notification on success
				location.reload();
			} else {
				toast.error(data.message || __('An error occurred while deactivating license.', 'uael'));
				setErrorMessage(data.message || __('An error occurred while deactivating license.', 'uael'));
			}
		});
	};

	return (
		<>
			<Toaster
				position="top-right"
				reverseOrder={false}
				gutter={8}
				containerStyle={{
					top: 20,
					right: 20,
					marginTop: '40px',
				}}
				toastOptions={{
					duration: 5000,
					style: {
						background: 'white',
					},
					success: {
						duration: 3000,
						iconTheme: {
							primary: '#6005ff',
							secondary: '#fff',
						},
					},
				}}
			/>
			<Title
				description=""
				icon={null}
				iconPosition="right"
				size="sm"
				tag="h2"
				title={__('My Account', 'uael')}
			/>
			<Container
				align="stretch"
				className="bg-background-primary p-6 rounded-lg uael-78-width"
				containerType="flex"
				direction="column"
				gap="sm"
				justify="start"
				style={{
					marginTop: "24px",
				}}
			>
				<Container.Item className="flex flex-col space-y-2">
					<p className='text-base font-semibold m-0'>{__('License Key', 'uael')}</p>
					<p className='text-sm font-normal m-0'>{__('Please enter your valid license key below to activate ' + uaelSettingsData.plugin_name + '!', 'uael')}</p>
				</Container.Item>
				<Container.Item
					className="flex flex-col lg:flex-row gap-2 items-center space-y-2"
					alignSelf="auto"
					order="none"
				>
					<input
						value={licenseKey}
						onChange={(e) => setlicenseKey(e.target.value)}
						placeholder={licensePlaceholder}
						readOnly={licenseStatus}
						size="md"
						type="text"
						className={`w-full shrink ${licenseStatus ? 'uael-green-placeholder' : ''}`}
						style={{
							height: '48px',
							outline: 'none',       // Removes the default outline
							boxShadow: 'none',     // Removes the default box shadow
							borderColor: errorMessage ? 'red' : 'inherit',
						}}
						onFocus={(e) => e.target.style.borderColor = '#6005FF'} // Apply focus color
						onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}  // Revert to default color
					/>
					<div className='cursor-pointer mb-2 shrink'
						style={{ minWidth: "fit-content" }}>
						<Button
							icon={loading ? <LoaderCircle className="animate-spin" /> : null}
							iconPosition="left"
							style = {{ paddingTop: '14px', paddingBottom: '14px' }}
							className="bg-[#6005FF] mb-2"
							variant="primary"
							onClick={licenseStatus ? deactivateHandler : activateHandler}
							disabled={loading} // Disable button during loading to prevent multiple clicks.
						>
							{loading
								? (licenseStatus ? __('Deactivating...', 'uael') : __('Activating...', 'uael'))
								: (licenseStatus ? __('Deactivate License', 'uael') : __('Activate License', 'uael'))}
						</Button>
					</div>
				</Container.Item>
				{errorMessage && (
					<p className="text-red-500 text-xs" style={{ color: 'red', marginTop: "-10px" }}>{errorMessage}</p> // Show error message below the input field
				)}
			</Container>
		</>
	);
};

export default MyAccount;
